import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button"; // Using MUI Button instead of custom bootstrap Button
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom"; // For navigation
import { Container, Typography } from "@mui/material"; // MUI components for layout
import AddIcon from "@mui/icons-material/Add";
const Procedure = () => {
  const token = localStorage.getItem("Thyra_Token");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const MySwal = withReactContent(Swal);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  const dataGridStyle = {
    background: "white",
    fontSize: "10px",
    color: "black !important",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "white",
      color: "#ffffff",
      "& .MuiDataGrid-columnHeaderTitle": {
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    "& .MuiDataGrid-cell": {
      fontSize: "14px",
    },
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#fff",
      color: "#000",
      padding: "5px",
    },
  };

  const permissions = localStorage.getItem("permissionStored");
  const parsedPermissions = JSON.parse(permissions);
  console.log("add_procedure permission:", parsedPermissions.add_procedure);
  const addPermission = parsedPermissions.add_procedure;


  const openProcedureRegistration = (id = 0) => {
    navigate('/ProcedureRegistration', { state: { ProcedureId: id } });
  };
  const [rows, setRows] = useState([]);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.03,
    },
    {
      field: "code",
      headerName: "Code",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
        sx={{
          color: "#000000",
          textTransform: "none",
          justifyContent: "flex-start",
          fontWeight: "bold",
          fontSize: "0.95rem",
          "&:hover": {
            color: "#195C5F",
            textDecoration: "underline",
            transition: "color 0.2s ease-in-out",
          },
        }}
          onClick={() => openProcedureRegistration(cellValues.row.id)}
        >
          {`${cellValues.row.code}`}
        </Button>
      ),
    },
    {
      field: "charges",
      headerName: "Charges",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "modifier1",
      headerName: "Modifier1",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "modifier2",
      headerName: "Modifier2",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "modifier3",
      headerName: "Modifier3",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },
    {
      field: "description",
      headerName: "Description",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
    },

    {
      field: "isActive",
      headerClassName: "super-app-theme--header",
      headerName: "Action",
      sortable: true,
      width: 90,
      renderCell: (cellValues) => (
        <DeleteIcon
          style={{
            marginRight: "5px",
            marginTop: "5px",
            color: "red",
            cursor: "pointer",
          }}
          onClick={() => {
            MySwal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "No, cancel!",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                MySwal.fire({
                  title: "Deleted!",
                  text: "Your file has been deleted.",
                  icon: "success",
                  timer: 1000,
                });

                const postData = {
                  id: cellValues.row.id,
                  inactive: true,
                };

                axios
                  .post(
                    `${process.env.REACT_APP_STORYBOOK_URL}/Procedures/DeleteProcedure?id=${cellValues.row.id}`,
                    postData,
                    { headers }
                  )
                  .then(() => {
                    setRefresh(!refresh);
                  })
                  .catch((error) => {
                    console.error("There was an error!", error);
                  });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                MySwal.fire({
                  title: "Cancelled",
                  text: "Your file is safe :)",
                  icon: "error",
                  timer: 1000,
                });
              }
            });
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/getProcedures`, {
        headers,
      })
      .then((response) => {
        setIsLoading(false);
        setRows(response); // Adjusted to response.data
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      });
  }, [refresh]);

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      {/* <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2B7B7E" }}>
          Procedure
        </Typography>
      </Box> */}

      <div className="row">
        <div className="col-md-10"></div>
        <Box sx={{ mb: 3, display: "flex", justifyContent: "flex-end" }}>

          {
            addPermission? 
            (

         
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => openProcedureRegistration()}
            sx={{
              bgcolor: "#2B7B7E",
              color: "#FFFFFF",
              borderRadius: "80px",
              textTransform: "none",
              fontWeight: 500,
              px: 3,
              py: 1,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                bgcolor: "#77A2A7",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
                transition: "all 0.3s",
              },
            }}
          >
            Add Procedure
          </Button>
             ): (null)
            }
        </Box>
      </div>
      <div className="row d-flex align-items-center h-100">
        <div
          className="col-12 d-flex justify-content-center align-items-center"
          style={{ fontSize: "calc(1rem + 1vw)" }}
        >
          <Box sx={{ height: 400, width: "100%", marginTop: "1.5rem" }}>
            {isLoading ? (
              <CircularProgress
                style={{
                  width: "50px",
                  height: "50px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  marginLeft: "-25px",
                  marginTop: "-25px",
                  zIndex: 1000,
                  color: "#7C246C",
                }}
              />
            ) : (
              <DataGrid
                rows={rows}
                columns={columns}
                sx={dataGridStyle}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
              />
            )}
          </Box>
        </div>
      </div>
    </Container>
  );
};

export default Procedure;
